import * as yup from "yup";
import { requiredIdentitySideSchema } from "screens/Private/Broker/Projects/Detail/Templates/Comparison/Acoris/utils/identityDocuments";

const validation = (messages) => {
  return yup.object().shape({
    cinRecto: requiredIdentitySideSchema(messages),
    cinVerso: requiredIdentitySideSchema(messages),
    socialSecurityCertificate: yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().required(messages.REQUIRED),
        }),
      )
      .required(messages.REQUIRED_ATTACHMENT)
      .min(1, messages.REQUIRED_ATTACHMENT)
      .max(1, messages.ONE_FILE),
  });
};

export default validation;
